import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NgxSpinnerService} from 'ngx-spinner';
import {ModulesService} from '../../../../../core/services/modules.service';

@Component({
    selector: 'edit-module',
    templateUrl: './edit-module.modal.html',
    styleUrls: ['./edit-module.modal.scss'],
    standalone: false
})

export class EditModuleModal {
  public info;
  constructor( public dialogRef: MatDialogRef<EditModuleModal>,
               @Inject(MAT_DIALOG_DATA) public data: any,
               public modulesService: ModulesService, private spinner: NgxSpinnerService) {
    this.info = data;
  }

  edit() {
    this.spinner.show();
    for (let i = 0; i < this.info.matrixModule.length; i++) {
      let module = this.info.matrixModule[i];
      if (module?.modules) {
        let obj = {
          organizationId: this.info.id,
          modulesId: module.modules.id,
          enable: module.enable
        };
        this.modulesService.addMatrixModule(obj).subscribe(res => {
          if (i === this.info.matrixModule.length - 1) {
            setTimeout(() => {
              this.spinner.hide();
              this.dialogRef.close();
            }, 500);
          }
        });
      }
    }
  }
}
